module.exports = require("react-inlinesvg");